<template>
    <div>
        <div class="calendar-picker">
            <div class="calendar-picker__month-select">
                <select type="select" class="form-select date-selector" style="min-width: 138px" v-model="month">
                    <option :key="index" :value="index" v-for="(month, index) in months">{{ month }}</option>
                </select>
                <select type="select" class="form-select date-selector" v-model="year">
                    <option :key="index" :value="year" v-for="(year, index) in years">{{ year }}</option>
                </select>
            </div>
            <div class="calendar-picker-month">
                <div class="calendar-picker-week">
                    <div class="calendar-picker-day --weekday" v-for="week_day in week_days">{{ week_day }}</div>
                </div>
                <div class="calendar-picker-week" v-for="week in days">
                    <a href="#" @click.prevent="selectDate(date.date)"
                       class="calendar-picker-day"
                       v-for="date in week"
                       :class="{'today': date && date.date == selected_date,
                                '--has-bookings': date && date_bookings && date_bookings[date.date] && date_bookings[date.date] > 0}">
                        {{ date ? date.day : '' }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
  name: 'CalendarPicker',
  props: ['value', 'date_bookings'],
  data() {
    return {
      calendar: null,
      today: null,
      selected_date: null,
      month: null,
      year: null,
      days: [],
      week_days: [ 'M', 'T', 'W', 'T', 'F', 'S', 'S'],
      months: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],
    }
  },
  created () {
    let today = moment();
    this.today = today.format('YYYY-MM-DD')
    this.month = today.month();
    this.year = today.year();
    this.selected_date = today.format('YYYY-MM-DD')

    this.generateCalendar()
  },
  computed: {
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: (year + 10) - 2020}, (value, index) => 2021 + index)
    }
  },
  watch: {
    year() {
      this.generateCalendar()
      this.$emit('changeYear', {
        year: this.year + 1,
      });
    },
    month() {
      this.generateCalendar()
      this.$emit('changeMonth', {
        year: this.year,
        month: this.month + 1
      });
    },
    selected_date() {
      this.$emit('change', this.selected_date)
    },
    value() {
      if (this.value != this.selected_date) {
        this.month = moment(this.value, 'YYYY-MM-DD').month();
        this.year = moment(this.value, 'YYYY-MM-DD').year();
        this.selected_date = this.value

      }
    }
  },
  methods: {
    selectDate(date) {
      this.selected_date = date;
    },
    setNextMonth() {
      if (this.month === 11) {
        this.month = 0;
        this.year += 1;
      } else {
        this.month += 1;
      }
    },
    setPrevMonth() {
      if (this.month === 1) {
        this.month = 11;
        this.year -= 1;
      } else {
        this.month -= 1;
      }
    },
    generateCalendar () {
      this.days = this.getDays()
    },
    getDays() {
      let firstDay = (new Date(this.year, this.month)).getDay() - 1;
      if (firstDay < 0) {
        firstDay = 6
      }

      let day = 1;
      let results = [];
      let lastDay = new Date(this.year, this.month + 1, 0).getDate()

      let month = this.$options.filters.pad(this.month + 1, 2)
      for (let i = 0; i < 6; i++) {
        results.push([])
        for (let j = 0; j < 7; j++) {
          if (i === 0 && j < firstDay) {
            results[i].push(null);
          } else if (day > lastDay) {
            break;
          } else {
            results[i].push({
              day: day,
              date: `${this.year}-${month}-${this.$options.filters.pad(day, 2)}`
            });
            day++;
          }
        }
      }

      return results
    }
  }
}
</script>
